import React, {PureComponent, HTMLAttributes, CSSProperties} from 'react'
import PropTypes from 'prop-types'
import Theme from 'Theme'
import cxs from 'cxs/component'

interface Props extends HTMLAttributes<HTMLSpanElement> {
  name: Icons
  size?: number
}

class Icon extends PureComponent<Props, Props> {
  render() {
    const {name, ...props} = this.props
    return <StyledIcon {...props}>{name}</StyledIcon>
  }
}

export default Icon

const StyledIcon = cxs('div')(
  ({size}) =>
    ({
      display: 'inline-block',
      fontFamily: 'icons',
      fontSize: size ? size + 'px' : Theme.fontSize.big,
      textTransform: 'initial',
      lineHeight: 1,
      padding: Theme.size.space[1]
    } as CSSProperties)
)

StyledIcon.propTypes = {
  size: PropTypes.number
}

type Icons =
  | 'arrow'
  | 'back'
  | 'card'
  | 'cash'
  | 'catalog'
  | 'cells'
  | 'clear'
  | 'cp'
  | 'del'
  | 'enter'
  | 'hide'
  | 'lines'
  | 'logo'
  | 'menu'
  | 'mixed'
  | 'placeholder'
  | 'powered'
  | 'professional'
  | 'refund'
  | 'retail'
  | 'rows'
  | 'sale'
  | 'search'
  | 'send'
  | 'share'
  | 'show'
  | 'tick'



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/elements/Icon.tsx